"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeFunction = exports.humanizeClass = exports.humanizeType = void 0;
/**
 * Returns the type name of the given value.
 */
function humanizeType(value) {
    let type = typeof value;
    if (value === null) {
        return "null";
    }
    else if (type === "number" && Number.isNaN(value)) {
        return "NaN";
    }
    else if (type === "object") {
        return humanizeClass(value);
    }
    return type;
}
exports.humanizeType = humanizeType;
/**
 * Returns the class name of the given value.
 */
function humanizeClass(obj) {
    let name = Object.prototype.toString.call(obj).slice(8, -1);
    if ((name === "Object" || name === "Error") && obj.constructor) {
        return humanizeFunction(obj.constructor);
    }
    return name;
}
exports.humanizeClass = humanizeClass;
/**
 * Returns the name of the given function.
 */
function humanizeFunction(func) {
    if (func.name) {
        return func.name;
    }
    let match = /^\s*function\s*([^\(]*)/im.exec(func.toString());
    return match ? match[1] : "";
}
exports.humanizeFunction = humanizeFunction;
//# sourceMappingURL=humanize-type.js.map